<template lang="pug">
  .div
    .columns
      .column.is-4
        .field
          input#inpt1.is-checkradio(type='checkbox' v-model='cargador' :disabled="isDisabled")
          label.is-size-6(for='inpt1') Cargador
      .column.is-4
        .field
          input#inpt2.is-checkradio(type='checkbox' v-model='audifonos' :disabled="isDisabled")
          label.is-size-6(for='inpt2') Audífonos
      .column.is-4
        .field
          input#inpt3.is-checkradio(type='checkbox' v-model='caja' :disabled="isDisabled")
          label.is-size-6(for='inpt3') Caja
    .columns
      .column.is-4
        .field
          input#inpt4.is-checkradio(type='checkbox' v-model='sim' :disabled="isDisabled")
          label.is-size-6(for='inpt4') SIM
      .column.is-4
        .field
          input#inpt5.is-checkradio(type='checkbox' v-model='protector' :disabled="isDisabled")
          label.is-size-6(for='inpt5') Protector
      .column.is-4
        .field
          input#inpt6.is-checkradio(type='checkbox' v-model='adaptador' :disabled="isDisabled")
          label.is-size-6(for='inpt6') Adaptador SD
    .columns
      .column.is-offset-3.is-3
        a.button.is-block(@click="cancelAdd")
          | Cancelar 
      .column.is-3
        a.button.is-black.is-block(@click="saveItems")
          | Guardar Items para Inventario
</template>

<script>
  export default {
    name: 'ListItems_Telefono',
    data() {
      return {
        cargador: null,
        audifonos: null,
        caja: null,
        sim: null,
        protector: null,
        adaptador: null,
        itemsSelected: {},
        isDisabled: false
      }
    },
    methods: {
      saveItems() {
        let myObj = {
          cargador: this.convertBoolToInt(this.cargador),
          audifonos: this.convertBoolToInt(this.audifonos),
          caja: this.convertBoolToInt(this.caja),
          sim: this.convertBoolToInt(this.sim),
          protector: this.convertBoolToInt(this.protector),
          adaptador: this.convertBoolToInt(this.adaptador)
        }
        this.isDisabled = true
        this.itemsSelected = Object.assign({}, this.itemsSelected, myObj)
        this.$emit('itemsSelected_Tel', myObj)
      },
      cancelAdd() {
        this.datosFaltantes = []
        this.isDisabled = false
        console.log('Cancelar')
        this.$emit('itemsSelected_Tel','close')
      },
      convertBoolToInt(val) {
        let valor = 0
        if (val) {
          valor = 1
        } else {
          valor = 0
        }
        return valor
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/ListItems_Telefono.vue